import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de-CH';
import localeEN from '@angular/common/locales/en';
import localeFR from '@angular/common/locales/fr-CH';
import localeIT from '@angular/common/locales/it-CH';
import {
  EnvironmentProviders,
  Injectable,
  makeEnvironmentProviders,
} from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import {
  MDS_TRANSLATE_LOADERS,
  provideMdsTranslation,
  provideMdsTranslationLocale,
} from '@mds/ngx-core';
import { FilterTranslationLoader } from '@mds/ngx-filter';
import { LayoutTranslationLoader } from '@mds/ngx-layout';
import { filter, from, Observable } from 'rxjs';

// TODO: https://dev.azure.com/techgroup/Maison%20du%20Software/_backlogs/backlog/Team%20Pioneer/Stories?workitem=42854
registerLocaleData(localeDE);
registerLocaleData(localeEN);
registerLocaleData(localeFR);
registerLocaleData(localeIT);

export function provideTranslations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MDS_TRANSLATE_LOADERS,
      useClass: AppTranslationLoader,
      multi: true,
    },
    {
      provide: MDS_TRANSLATE_LOADERS,
      useClass: LayoutTranslationLoader,
      multi: true,
    },
    {
      provide: MDS_TRANSLATE_LOADERS,
      useClass: FilterTranslationLoader,
      multi: true,
    },
    provideMdsTranslation(),
    provideMdsTranslationLocale(),
  ]);
}

@Injectable({ providedIn: 'root' })
export class AppTranslationLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    return from(import(`../../assets/i18n/${lang}.json`)).pipe(
      filter((translation): translation is Translation => !!translation),
    );
  }
}
